import React from "react";
import { useFindingDetails } from "./FindingDetailsProvider";
import { Tooltip, Typography } from "antd";
import { useActiveUserContext } from "contexts/ActiveUserContext";
import LinkIcon from "ac-components/ac-icons/LinkIcon";
import FindingDetailsAction from "./FindingDetailsAction";
import ACModalV2 from "ac-components/ac-modal/ACModalV2";
import ACEntityNavigator from "ac-components/ac-entity-navigator/ACEntityNavigator";
import ACModalPlacementMenu from "ac-components/ac-modal/ACModalPlacementMenu";
import Summary from "./ModalV3/Summary";

const { Text } = Typography;

export default function FindingDetailsTitle() {
  const { id, findingNavigatorProps, onFindingIdChange } = useFindingDetails();
  const { tenantId, businessUnitId } = useActiveUserContext();
  const modalSettings = ACModalV2.useModalSettings();

  return (
    <div className="finding-detail-modal-v3-title">
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <ACModalPlacementMenu
            currentPlacement={modalSettings.placement}
            onPlacementChange={(placement) => modalSettings.updatePlacement(placement)}
          />
          <div className="m-l-xs">
            {id}
            <Text
              className="finding-link-copy-icon"
              copyable={{
                tooltips: ["", ""],
                text: `${window.location.origin}/#/u/${tenantId}/${businessUnitId}/findings/${id}`,
                icon: [
                  <Tooltip key="link-icon" title="Copy link for finding Detail" placement="right">
                    <LinkIcon
                      key="copy-icon"
                      className="font-size-16"
                      style={{ color: "#00113499" }}
                    />
                  </Tooltip>,
                  <Tooltip key="copied-icon" title="Copied" placement="right">
                    <LinkIcon
                      key="copied-icon"
                      className="font-size-16"
                      style={{ color: "#00113499" }}
                    />
                  </Tooltip>,
                ],
              }}
            />
          </div>
        </div>
        <div>
          <ACEntityNavigator
            navigatorParams={findingNavigatorProps}
            onEntityChange={onFindingIdChange}
            className="m-r-xs"
            containerClassName="finding-detail-modal-wrapper"
          />
          <FindingDetailsAction />
        </div>
      </div>
      <div className="finding-detail-modal-v3-summary m-t-sm">
        <Summary />
      </div>
    </div>
  );
}